import api from "@/lib/api";
import { format } from "date-fns";
import { it } from "date-fns/locale";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Resolve a stored image path to a fully-qualified URL. */
export const mediaUrl = (u) => {
  if (!u) return "";
  return u.startsWith("http") ? u : `${BACKEND}${u}`;
};

/** '2021-02-28' -> '28 febbraio 2021'. Falls back to the raw string. */
export const formatNewsDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
    if (isNaN(d.getTime())) return iso;
    return format(d, "d MMMM yyyy", { locale: it });
  } catch (e) {
    return iso;
  }
};

/** Slug leggibile da un titolo: 'PGT Milano 2026: ...' -> 'pgt-milano-2026-...' */
export const newsSlug = (title) =>
  (title || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);

export const articleSlug = (article) => article.slug || newsSlug(article.title);
export const newsPath = (article) => `/news/${articleSlug(article)}`;

export const newsApi = {
  list: () => api.get("/news").then((r) => r.data),
  get: (id) => api.get(`/news/${id}`).then((r) => r.data),
  adminAll: () => api.get("/news-admin/all").then((r) => r.data),
  create: (payload) => api.post("/news-admin", payload).then((r) => r.data),
  update: (id, patch) => api.put(`/news-admin/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/news-admin/${id}`).then((r) => r.data),
  uploadImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api
      .post("/news-admin/upload-image", fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data);
  },
};

export const analyticsApi = {
  track: (visitor_id, path) => api.post("/analytics/track", { visitor_id, path }),
  stats: (days = 30) => api.get(`/analytics/stats?days=${days}`).then((r) => r.data),
};
